module.exports = __webpack_public_path__ + "img/indonesia.50d8fada.svg";